import { useEffect, useState, useSyncExternalStore } from 'react';
import { CheckMonitorSession } from './checkMonitorSession';

export const useCheckMonitor = () => {
  const [session] = useState(() => new CheckMonitorSession());
  const state = useSyncExternalStore(session.subscribe, session.getSnapshot);
  useEffect(() => session.start(), [session]);
  return {
    ...state,
    setPeriod: session.setPeriod,
    navigate: session.navigate,
    refresh: session.refresh,
  };
};
